import React, { useState } from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { P1 } from '../../../../components/Typographies/Paragraph';
import { H5 } from '../../../../components/Typographies/Title';
import ChevronDown from '../../../../images/icons/chevron-down.svg';

const Container = styled.div`
  ${tw`border border-solid border-secondary-400 p-big rounded-30 bg-white`}
  height: max-content
`;

const Header = styled.div`
  ${tw`flex `}
  gap: var(--size-big);
`;

const HeaderWrapper = styled.div`
  ${tw`w-full flex justify-between`}
  gap: var(--size-medium);
`;

const Button = styled.button``;

const Icon = styled.img<{ reverse: boolean }>`
  ${tw`border border-solid border-secondary-400 rounded-full p-small`}
  width: 32px;
  height: 32px;
  ${({ reverse }) => reverse && 'transform: rotate(180deg)'}
`;

const Index = styled(P1)`
  ${tw`hidden md:block`}
  white-space: nowrap;
`;

const Wrapper = styled.div`
  ${tw`w-full flex flex-col`}
  gap: var(--size-small)
`;

interface AccordionProps {
  children?: React.ReactNode | string;
  header: React.ReactNode | string;
  index?: number;
  isOpenByDefault?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  children,
  header,
  index,
  isOpenByDefault = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenByDefault);

  return (
    <Container>
      <Header>
        {index && <Index>{`${index}`.padStart(2, '0')}</Index>}
        <Wrapper>
          <HeaderWrapper
            onClick={() => setIsOpen((isCurrentlyOpen) => !isCurrentlyOpen)}
          >
            <H5 as="h3">{header}</H5>

            <Button>
              <Icon alt="Chevron icon" reverse={isOpen} src={ChevronDown} />
            </Button>
          </HeaderWrapper>

          {isOpen && <div>{children}</div>}
        </Wrapper>
      </Header>
    </Container>
  );
};

export default Accordion;
